type SdpCta = 'ADP_BID' | 'DSDP_PLACE_ORDER' | 'DSDP_START_NEGOTIATION';

type UseResumeSdpCtaFlowReturn = Ref<SdpCta | null>;

export const useResumeSdpCtaFlow = (): UseResumeSdpCtaFlowReturn => useState('resumeSdpCtaFlow', () => null);
